import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';

import { NgSelectModule } from '@ng-select/ng-select';
import { ColorPickerModule } from 'ngx-color-picker';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';
import { MgPipesModule } from '@app/src/app/pipes';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { FormModule } from '@shared/components/form';
import { FormRestrictionModule } from '@shared/components/form-restriction-input/form-restriction-input.module';
import { GenericModule } from '@shared/components/generic';
import { ImageViewerModalModule } from '@shared/components/image-viewer-modal';
import { OverlayModule } from '@shared/components/modal-overlay';
import { PaginatorModule } from '@shared/components/paginator';
import { SystemAlertModule } from '@shared/components/system-alert';
import { TextModule } from '@shared/components/text';
import { TilesCarouselModule } from '@shared/components/tiles-carousel';
import { TooltipModule } from '@shared/components/tooltip';

import { CheckinManagerReasonsComponent } from './checkin-manager-reasons.component';
import { CheckinManagerReasonsEditComponent } from './components/checkin-manager-reasons-edit/checkin-manager-reasons-edit.component';
import { CheckinManagerReasonsTableComponent } from './components/checkin-manager-reasons-table/checkin-manager-reasons-table.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgSpinnerModule,
    MgIconModule,
    MgEmptyStateModule,
    OverlayModule,
    MgPipesModule,
    MgFormFieldModule,
    TilesCarouselModule,
    MgImageModule,
    TooltipModule,
    FormModule,
    ColorPickerModule,
    FormRestrictionModule,
    ImageViewerModalModule,
    TextModule,
    GenericModule,
    SystemAlertModule,
    PaginatorModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    MatTableModule,
    MatSortModule,
    MatSnackBarModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonToggleModule,
    NgSelectModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatTooltipModule,
  ],
  declarations: [
    CheckinManagerReasonsComponent,
    CheckinManagerReasonsEditComponent,
    CheckinManagerReasonsTableComponent,
  ],
  exports: [CheckinManagerReasonsComponent, CheckinManagerReasonsEditComponent, CheckinManagerReasonsTableComponent],
})
export class CheckinManagerReasonsModule {}
